import {
  CheckCircleFilled,
  InfoCircleOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { Button, Skeleton, Tooltip } from "antd";
import { useEffect, useState } from "react";

const BankBlocks = () => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  return (
    <>
      <div className="white-block">
        <div className="grey">
          <h1 className="">Банковские продукты</h1>
          <span>
            <CheckCircleFilled className="green" /> <b>Персональные</b>{" "}
            предложения банка, основанные на вашем рейтинге и данных предприятия
          </span>
        </div>

        <div className="grid4">
          <div className="bank-block">
            {loading ? (
              <Skeleton active loading={loading} paragraph={{ rows: 4 }} />
            ) : (
              <>
                <div>
                  <div
                    className="bank-img"
                    style={{ backgroundImage: `url("/Image.png")` }}
                  ></div>
                  <div className="bank-block-white">
                    <h1>Субсидированное кредитование</h1>
                    <div className="text-bottom">
                      <div className="grey">
                        Доступные субсидированные программы:{" "}
                      </div>
                      <b> 2</b> программы
                    </div>
                    <div className="text-bottom">
                      <div className="grey">Процентная ставка: </div>
                      <b> 5%</b> годовых
                    </div>
                    <div className="text-bottom">
                      <div className="grey">Срок действия программы: </div>
                      <b> 6</b> месяцев
                    </div>
                  </div>
                </div>
                <Button>Узнать детали</Button>
              </>
            )}
          </div>
          <div className="bank-block">
            {loading ? (
              <Skeleton active loading={loading} paragraph={{ rows: 4 }} />
            ) : (
              <>
                <div>
                  <div
                    className="bank-img"
                    style={{ backgroundImage: `url("/Image.png")` }}
                  ></div>
                  <div className="bank-block-white">
                    <h1>Контрактное финансирование</h1>
                    <div className="text-bottom">
                      <div className="grey">
                        Доступные средства под контракты:
                      </div>
                      <b> 20 000 000</b> руб.
                    </div>
                    <div className="text-bottom">
                      <div className="grey">
                        Процент одобрения заявок по контрактам:{" "}
                      </div>
                      <b> 100%</b> годовых
                    </div>
                    <div className="text-bottom">
                      <div className="grey">
                        Среднее время рассмотрения заявки:{" "}
                      </div>
                      <b> 2</b> дня
                    </div>
                  </div>
                </div>
                <Button>Узнать детали</Button>
              </>
            )}
          </div>
          <div className="bank-block">
            {loading ? (
              <Skeleton active loading={loading} paragraph={{ rows: 4 }} />
            ) : (
              <>
                <div>
                  <div
                    className="bank-img"
                    style={{ backgroundImage: `url("/Image.png")` }}
                  ></div>
                  <div className="bank-block-white">
                    <h1>Отсрочка платежа / платежная гарантия</h1>
                    <div className="text-bottom">
                      <div className="grey">Максимальный срок отсрочки:</div>
                      <b> 2</b> месяца
                    </div>
                    <div className="text-bottom">
                      <div className="grey">Максимальная сумма отсрочки: </div>
                      <b> 500 000</b> руб.
                    </div>
                    <div className="text-bottom">
                      <div className="grey">
                        Уровень доверия со стороны банка:{" "}
                      </div>
                      <b> 94</b>
                    </div>
                  </div>
                </div>
                <Button>Узнать детали</Button>
              </>
            )}
          </div>
          <div className="bank-block block4">
            {loading ? (
              <Skeleton active loading={loading} paragraph={{ rows: 4 }} />
            ) : (
              <>
                <div
                  className="bank-img"
                  style={{
                    backgroundImage: `url("/bank.png")`,
                    height: "100%",
                  }}
                >
                  <div className="center">
                    <h1 className="white">
                      Заполни карточку предприятия и получи больше предложений
                    </h1>
                    <Button className="white-btn">Заполнить карточку</Button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="margin-top">
          <h1 className="">Ближайшие мероприятия банка</h1>

          <div className="">
            <div className="grid4">
              {!loading ? (
                <div className="bank-block">
                  <div>
                    <h2 className="tiffany">25 сентября 2025</h2>
                    <h2>Семинар “Кредит с нуля” Второй поток</h2>
                    <p>
                      Совместно со специалистами кредитного отдела разберем
                      эффективный план коммуникации по оформлению кредитоного
                      продукта
                    </p>
                  </div>
                  <Button>Подробности</Button>
                </div>
              ) : (
                <Skeleton active loading={loading} paragraph={{ rows: 2 }} />
              )}
              {!loading ? (
                <div className="bank-block">
                  <div>
                    <h2 className="tiffany">20 сентября 2025</h2>
                    <h2>Семинар “Кредит с нуля”</h2>
                    <p>
                      Разберем эффективный план коммуникации по оформлению
                      кредитоного продукта
                    </p>
                  </div>
                  <Button>Подробности</Button>
                </div>
              ) : (
                <Skeleton active loading={loading} paragraph={{ rows: 2 }} />
              )}
              {!loading ? (
                <div className="bank-block">
                  <div>
                    <h2 className="tiffany">12 сентября 2025</h2>
                    <h2>Семинар “Кредит с нуля”</h2>
                    <p>
                      Совместно со специалистами кредитного отдела разберем
                      эффективный план коммуникации по оформлению кредитоного
                      продукта
                    </p>
                  </div>
                  <Button>Подробности</Button>
                </div>
              ) : (
                <Skeleton active loading={loading} paragraph={{ rows: 2 }} />
              )}
              {!loading ? (
                <div className="bank-block">
                  <div>
                    <h2 className="tiffany">2 сентября 2025</h2>
                    <h2>Семинар “Кредит с нуля”</h2>
                    <p>
                      Совместно со специалистами кредитного отдела разберем
                      эффективный план коммуникации по оформлению кредитоного
                      продукта
                    </p>
                  </div>
                  <Button>Подробности</Button>
                </div>
              ) : (
                <Skeleton active loading={loading} paragraph={{ rows: 2 }} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default BankBlocks;
